<template>
    <div class="row justify-content-center">
        <div class="col-10">
            <Loader v-if="row.item.flags === undefined" />
            <div v-else-if="row.item.flags && row.item.flags.length" class="row flags_row">
                <div class="col-12">
                    <h4>{{ $t("flags") }}</h4>
                    <div class="row align-items-center flags_row_item" v-for="n in row.item.flags" :key="n.id">
                        <div class="col col-1 text-center">
                            <RiskLevelDumpling :value="n.risk" :level="versionRiskLevel(n, version)" />
                        </div>
                        <div class="col col-11 flag_description">
                            <h5>
                                {{ n.flag_type_name }}
                                <a :href="flagUrl(n.flag_type_documentation_url)" target="_blank" v-if="n.flag_type_documentation_url">
                                    <b-icon-question-circle
                                        font-scale="0.95"
                                        variant="dark"
                                        class="ml-1"
                                    />
                                </a>
                            </h5>
                            <p>{{ n.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import RiskLevelDumpling from "@/components/RiskLevelDumpling.vue";
import riskMixin from "@/plugins/riskMixin.js";

export default {
    props: {
        row: { type: Object, required: true },
        version: { required: true }
    },
    mixins: [riskMixin],
    components: { Loader, RiskLevelDumpling },
    methods: {
        flagUrl(documentation_url){
            return "https://popisrizik.datlab.eu" + documentation_url
        }
    }
};
</script>

<style lang="scss">
@import "src/scss/custom";
.flags_row {
    margin-top: 15px;
    margin-bottom: 15px;

    h4 {
        font-size: 16px;
    }

    h5 {
        font-size: 14px;
        font-weight: 700;
    }

    .flag_description p {
        font-size: 14px;
        margin-bottom: 0px;
    }

    .flags_row_item {
        margin-bottom: 20px;

        &:last-of-type {
            margin-bottom: 0px;
        }
    }
}
</style>
